import { Slider, withStyles } from "@material-ui/core";

const SLIDER_HEIGHT = 4;
const THUMB_WIDTH = 25;
const THUMB_HEIGHT = 15;
const BORDER_RADIUS = 2;

/**
 * This is only used by the Monthly Cover slider. Ideally we are moving away from @material-ui library into our own components.
 */

const LSlider = withStyles({
    root: {
        color: "#16ae8f",
        height: SLIDER_HEIGHT,
        margin: "0px 10px 0px 10px",
        "& .Mui-focusVisible": {
            borderColor: "#05D2FD",
            borderWidth: "4px",
            borderStyle: "solid",
        }
    },
    disabled: {
        "& .MuiSlider-thumb": {
            width: THUMB_WIDTH,
            height: THUMB_HEIGHT,
            marginTop: -(THUMB_HEIGHT - SLIDER_HEIGHT) / 2,
            marginLeft: -THUMB_WIDTH / 2,
            borderRadius: BORDER_RADIUS
        }
    },
    thumb: {
        "width": THUMB_WIDTH,
        "height": THUMB_HEIGHT,
        "borderRadius": BORDER_RADIUS,

        "marginTop": -(THUMB_HEIGHT - SLIDER_HEIGHT) / 2,
        "marginLeft": -THUMB_WIDTH / 2,
        "&:focus, &:hover, &$active": {
            boxShadow: "inherit"
        }
    },

    rail: {
        height: SLIDER_HEIGHT,
        color: "#d8d8d8"
    },
    track: {
        height: SLIDER_HEIGHT
    },
    active: {}
})(Slider);

export default LSlider;
